import { render, staticRenderFns } from "./CrawlerInspectionDetailsDialog.vue?vue&type=template&id=5ae54736&scoped=true&"
import script from "./CrawlerInspectionDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./CrawlerInspectionDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae54736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSelect,VTab,VTabItem,VTabs,VTabsItems})
